import React from 'react';
import { observer } from 'mobx-react-lite';

import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Draggable from "react-draggable";

import { useStore } from '../../stores';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const ApproveMultipleFile = observer(() => {
  const { viewStore, fileActionStore, searchStore } = useStore();
  const classes = useStyles();

  const modalTitle = `Duyệt file/folder đã chọn`;
  const openModal = fileActionStore.isShowApproveMultiple;

  const handleCloseModal = (e) => {
    e.preventDefault();
    fileActionStore.setShowModal('ApproveMultiple', false);
  };

  const handleClickSubmit = async (e) => {
    handleCloseModal(e);

    let ids = [];
    Object.keys(viewStore.isSelectedCheckbox)?.forEach(key => {
      if (viewStore.isSelectedCheckbox[key]) ids.push(key);
    });

    const resultSubmit = await fileActionStore.handleSubmitDocumentApprove({ ids });
    if (resultSubmit && resultSubmit.success) {
      if (searchStore.isSearch) searchStore.setAfterSearch(true);
      viewStore.enableRefreshList();
      viewStore.enableRefreshCurrentInfo();
    }
  }

  return (
    <div className="nk-fmg-actions" style={{ paddingBottom: '5px' }}>
      <ul className="nk-block-tools g-3">
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openModal}
          onClose={handleCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Draggable
            onDrag={(e) => { e.preventDefault(); }}
            bounds="parent"
            handle=".modal-header"
            cancel=".close"
          >
            <Fade in={openModal}>
              <div style={{ width: '500px' }} tabIndex="-1" role="dialog" id="file-approve-multiple" aria-modal="true">
                <div className="modal-dialog modal-md" role="document">
                  <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                      <h5 className="modal-title">{modalTitle}</h5>
                      <a href="# " className="close" style={{ cursor: 'pointer' }} onClick={handleCloseModal}>
                        <em className="icon ni ni-cross-sm"></em>
                      </a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                      <span> Bạn muốn duyệt tất cả file/folder đã chọn?</span>
                      <div className="nk-modal-action justify-end">
                        <ul className="btn-toolbar g-4 align-center">
                          <li><a href="# " className="link link-primary" onClick={handleCloseModal}> Bỏ qua </a></li>
                          <li><button className="btn btn-primary" onClick={handleClickSubmit}> Đồng ý </button></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </Draggable>
        </Modal>
      </ul>
    </div>
  );
})

export default ApproveMultipleFile;